"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Styles = require("../utils/Styles");

var _NormalColors = _interopRequireDefault(require("../core/NormalColors"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  border: ", " solid ", ";\n  box-shadow: 0 0 0 ", " ", ";\n  display: inline-block;\n  pointer-events: none;\n  text-align: center;\n  vertical-align: baseline;\n  ", ";\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  font-size: ", ";\n  ", ";\n  ", ";\n  background-color: ", ";\n  color: ", ";\n  display: inline-block;\n  line-height: ", ";\n  min-height: ", ";\n  padding: 0 8px;\n  text-align: center;\n  text-transform: uppercase;\n  vertical-align: inherit;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BADGE_COLORS = {
  beta: _colors.THUNDERDOME,
  default: _colors.LORAX,
  free: _colors.LORAX,
  new: _colors.OZ,
  none: null
};
var COUNT_BADGES = {
  count: null,
  dot: null
};
var BADGE_USES = (0, _extends2.default)({}, _NormalColors.default, BADGE_COLORS, COUNT_BADGES);
var NOTIFICATION_BADGE_BORDER_WIDTH = '1px';
var NOTIFICATION_BADGE_DEFAULT_SIZE = '21px';
var NOTIFICATION_BADGE_FONT_SIZE = '11px';
var NOTIFICATION_BADGE_SMALL_SIZE = '10px';
var COMPUTED_LINE_HEIGHT = (0, _Styles.toPx)(parseInt(NOTIFICATION_BADGE_DEFAULT_SIZE, 10) - parseInt(NOTIFICATION_BADGE_BORDER_WIDTH, 10) * 2);

var StyledBadge = _styledComponents.default.span.attrs({
  className: function className(props) {
    return (0, _classNames.default)('private-badge', props.className);
  }
}).withConfig({
  displayName: "UIBadge__StyledBadge",
  componentId: "sc-13fhco0-0"
})(_templateObject(), _Styles.FONT_FAMILIES.bold, _sizes.BADGE_ROUNDED_FONT_SIZE, (0, _Styles.setFontSmoothing)('antialiased'), (0, _Styles.setBorderRadius)(), function (props) {
  return BADGE_USES[props.use];
}, _colors.OLAF, _sizes.BADGE_ROUNDED_HEIGHT, _sizes.BADGE_ROUNDED_HEIGHT);

var countStyles = "\n  " + _Styles.FONT_FAMILIES.demibold() + ";\n  font-size: " + NOTIFICATION_BADGE_FONT_SIZE + ";\n  " + (0, _Styles.setFontSmoothing)('antialiased') + ";\n  border-radius: 500px;\n  color: " + _colors.OLAF + ";\n  line-height: " + COMPUTED_LINE_HEIGHT + ";\n  min-height: " + NOTIFICATION_BADGE_DEFAULT_SIZE + ";\n  min-width: " + NOTIFICATION_BADGE_DEFAULT_SIZE + ";\n  padding: 0 4px;\n";
var dotStyles = "\n  border-radius: 100%;\n  height: " + NOTIFICATION_BADGE_SMALL_SIZE + ";\n  text-indent: -1000rem;\n  width: " + NOTIFICATION_BADGE_SMALL_SIZE + ";\n";

var CountBadge = _styledComponents.default.span.attrs({
  className: function className(props) {
    return (0, _classNames.default)(props.className, {
      'private-badge--count': props.use === 'count',
      'private-badge--dot': props.use === 'dot'
    });
  }
}).withConfig({
  displayName: "UIBadge__CountBadge",
  componentId: "sc-13fhco0-1"
})(_templateObject2(), _colors.NORMAN, NOTIFICATION_BADGE_BORDER_WIDTH, _colors.OLAF, NOTIFICATION_BADGE_BORDER_WIDTH, _colors.OLAF, function (props) {
  return props.use === 'count' ? countStyles : null;
}, function (props) {
  return props.use === 'dot' ? dotStyles : null;
});

var UIBadge = function UIBadge(props) {
  var children = props.children,
      className = props.className,
      use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "className", "use"]);
  var RenderedBadge = !(use === 'count' || use === 'dot') ? StyledBadge : CountBadge;
  return _react.default.createElement(RenderedBadge, (0, _extends2.default)({}, rest, {
    className: className,
    use: use
  }), children);
};

UIBadge.propTypes = {
  children: _react.PropTypes.node.isRequired,
  use: _react.PropTypes.oneOf(Object.keys(BADGE_USES))
};
UIBadge.defaultProps = {
  use: 'free'
};
UIBadge.displayName = 'UIBadge';
var _default = UIBadge;
exports.default = _default;
module.exports = exports.default;